import React, { useState, useEffect } from 'react';
import {
  Container,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody
} from 'reactstrap';
import { connect } from 'react-redux';
import { IMinuteCommentEdit, IAuthReduxProps, ITarget } from '../../types/interfaces';

import Select from 'react-select';
import { getUsers } from '../../flux/actions/userActions';
import { editVenteMinuteComment } from '../../flux/actions/venteActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faCommentDots, faPen, faPlus, faSpinner, faSquare, faTimes } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import { PRIVILEGE } from '../../types/privileges';

const MinuteCommentEdit = ({
  modal,
  setModal,
  modalData,
  editVenteMinuteComment,
  auth
 }: IMinuteCommentEdit) => {
  const alert = useAlert();

  const [idValue, setIdValue] = useState(-1);
  const [comment, setComment] = useState('');
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);
  
  const handleToggle = () => setModal(!modal);

  const modalOpenedHandle = () => {
    if(modalData && modalData !== ''){
      setIdValue(modalData["id"]);
      setComment(modalData["minuteComment"] || '');
    }
  };

  const modalClosedHandle = () => {
    setIdValue(-1);
    setComment('');
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };
  
  const commentChangeHandler = (e: ITarget) => setComment(e.target.value);
  
  const callback = (success) => {
    if(success){
      setReEnable(true);
      setModal(false);
      alert.success("Observation modifiée avec succès");
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const editHandle = async () => {
    setDisableSubmit(true);
    editVenteMinuteComment(idValue, comment, auth?.user?.id, callback);
  };

  return (
    <div>
      <Modal isOpen={modal} toggle={handleToggle} onOpened={modalOpenedHandle} onClosed={modalClosedHandle}>
        <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faCommentDots} />&nbsp;&nbsp;Observation Minute</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="comment">Observation</Label>
                    <Input id="comment" placeholder="Observation..." disabled={!auth?.user?.privileges?.includes(PRIVILEGE.ENREGISTREMENT_MINUTE)} value={comment} onChange={commentChangeHandler} />
                  </FormGroup>
                </Col>
              </Row>
              {!!auth?.user?.privileges?.includes(PRIVILEGE.ENREGISTREMENT_MINUTE) && <Row className="justify-content-center">
                <Button
                  className="btn btn-success linesConfirmationBtn"
                  onClick={editHandle}
                  disabled={disableSubmit}
                  ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faCheckCircle} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Modifier</Button>
              </Row>}
            </Container>
        </ModalBody>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { editVenteMinuteComment, getUsers })(MinuteCommentEdit);
